<template>
    <div class="campaign-option" dusk="ad-set-schedule">
        <div class="campaign-option--subtitle">
            Time Brackets <span v-if="!featureFlag('ad-set-schedule-timezone')">(Eastern Time)</span>
            <info-tooltip text="Make your selections for specific days and times. Keep in mind, the ad schedules you set are based on Eastern Time.<br>Please adjust your ad schedule to target customers' time zones."></info-tooltip>
        </div>

        <div class="m-t-sm">
            <!-- Need to use a guid for the key so the time-slot component is never reused -->
            <div v-for="(timeSlot, index) in timeSlots" :key="guid()" :dusk="`time-slot-${index}`">
                <time-slot
                    :timeSlot="timeSlot"
                    :overlaps="overlaps[index]"
                    @input="updateParent"
                    @remove="removeTimeSlot(timeSlot)">
                </time-slot>
            </div>

            <div v-if="overlapCount" class="m-t-sm m-b-sm" dusk="overlap-warning">
                <label class="error">Time periods overlap. Please adjust your ad schedules.</label>
            </div>

            <button @click.prevent="addTimeSLot" dusk="add-time-slot-btn" class="btn m-b-sm p-l-none">+ Add Time Slot</button>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import uuid4 from 'uuid4'
import TimeSlot from './time-slot';
import TimeSlotCollection from './models/time-slot-collection';
import TimeSlotAdapter from './services/time-slot-adapter';
import OverlapDetector from './services/overlap-detector';

export default {
    props: {
        value: Array
    },
    data() {
        return {
            timeSlots: []
        }
    },
    created() {
        let adapted = TimeSlotAdapter.to(this.value);

        let collection = new TimeSlotCollection(adapted);

        if (collection.isEmpty()) {
            collection.addDefault();
        }

        collection.sort();

        this.timeSlots = collection.toArray();

        this.updateParent();
    },
    computed: {
        timeSlotCollection() {
            return new TimeSlotCollection(this.timeSlots);
        },
        overlaps() {
            return OverlapDetector.getOverlaps(this.timeSlots);
        },
        overlapCount() {
            const overlapsCount = _.sumBy(this.overlaps);
            this.$emit('hasOverlaps', overlapsCount > 0)
            return overlapsCount;
        }
    },
    methods: {
        guid() {
            return uuid4();
        },
        updateParent() {
            const adapted = TimeSlotAdapter.from(this.timeSlotCollection.getExpanded());

            this.$emit('input', adapted);
        },
        addTimeSLot() {
            this.timeSlotCollection.addDefault();

            this.timeSlots = this.timeSlotCollection.toArray();

            this.updateParent();
        },
        removeTimeSlot(timeSlot) {
            this.timeSlotCollection.remove(timeSlot);

            this.timeSlots = this.timeSlotCollection.toArray();

            this.updateParent();
        }
    },
    components: {
        TimeSlot
    }
}
</script>

<style scoped>
    .p-l-none {
        padding-left: 0 !important;
    }
</style>
